export default "__VITE_ASSET__DnY_VwDm__"